import { settings } from "../../../../../shim/jsbridge";
import { COMPONENT_IDS } from "../../../consts";
import { DataBlockItem } from "../@types";
import { ComponentsWidth } from "./components-width";

export const DESCRIPTIONS: Record<string, string> = {
  [COMPONENT_IDS.SAMPLE_INFORMATION]:
    "Hashes, first & last seen, filenames, uploaders, user & system tags.",
  [COMPONENT_IDS.SAMPLE_DESCRIPTION]:
    "Detailed sample characteristics with ability to search for similar samples.",
  [COMPONENT_IDS.RELATIONSHIP_GRAPH]:
    "Visual overview of sample relations and their classifications.",
  [COMPONENT_IDS.MITRE]:
    "Triggered tactics and techniques from static & dynamic analysis.",
  [COMPONENT_IDS.ATTRIBUTION_DATA]:
    "Threat family & actor info, prevalence, and related samples.",
  [COMPONENT_IDS.NETWORK_REFERENCES]:
    "Top 5 extracted & contacted URIs/Domains/IPs, ranked by classification.",
  [COMPONENT_IDS.STATIC_ANALYSIS_INSIGHTS]:
    "Top 5 static analysis indicators, ranked by Priority.",
  [COMPONENT_IDS.DYNAMIC_ANALYSIS_INSIGHTS]:
    "Top 5 dynamic analysis signatures, ranked by Risk factor.",
  [COMPONENT_IDS.YARA_MATCHES]:
    "Top 5 matched YARA rulesets, ranked by classification impact.",
  [COMPONENT_IDS.EMAIL]:
    "Email metadata, preview, and attachments, ranked by classification.",
  [COMPONENT_IDS.LLM_SUMMARY]: "AI Summary of the sample.",
  [COMPONENT_IDS.SOURCES]: "Sample data from connector EDR integrations",
  [COMPONENT_IDS.CONNECTORS]:
    "Sample records reported by connector integrations."
};

const components: Record<string, DataBlockItem> = {
  [COMPONENT_IDS.SAMPLE_INFORMATION]: {
    id: COMPONENT_IDS.SAMPLE_INFORMATION,
    title: "Sample Information",
    description: DESCRIPTIONS[COMPONENT_IDS.SAMPLE_INFORMATION],
    width: ComponentsWidth.HALF
  },
  [COMPONENT_IDS.SOURCES]: {
    id: COMPONENT_IDS.SOURCES,
    title: "Sources",
    description: DESCRIPTIONS[COMPONENT_IDS.SOURCES],
    width: ComponentsWidth.HALF
  },
  [COMPONENT_IDS.CONNECTORS]: {
    id: COMPONENT_IDS.CONNECTORS,
    title: "Connectors",
    description: DESCRIPTIONS[COMPONENT_IDS.CONNECTORS],
    width: ComponentsWidth.FULL
  },
  [COMPONENT_IDS.SAMPLE_DESCRIPTION]: {
    id: COMPONENT_IDS.SAMPLE_DESCRIPTION,
    title: "Sample Description",
    description: DESCRIPTIONS[COMPONENT_IDS.SAMPLE_DESCRIPTION],
    width: ComponentsWidth.HALF
  },
  [COMPONENT_IDS.RELATIONSHIP_GRAPH]: {
    id: COMPONENT_IDS.RELATIONSHIP_GRAPH,
    title: "Relationship Graph",
    description: DESCRIPTIONS[COMPONENT_IDS.RELATIONSHIP_GRAPH],
    width: ComponentsWidth.HALF
  },
  [COMPONENT_IDS.MITRE]: {
    id: COMPONENT_IDS.MITRE,
    title: "MITRE ATT&CK",
    description: DESCRIPTIONS[COMPONENT_IDS.MITRE],
    width: ComponentsWidth.HALF
  },
  [COMPONENT_IDS.ATTRIBUTION_DATA]: {
    id: COMPONENT_IDS.ATTRIBUTION_DATA,
    title: "Attribution Data",
    note: "Shown only for Suspicious and Malicious samples.",
    description: DESCRIPTIONS[COMPONENT_IDS.ATTRIBUTION_DATA],
    width: ComponentsWidth.FULL
  },
  [COMPONENT_IDS.NETWORK_REFERENCES]: {
    id: COMPONENT_IDS.NETWORK_REFERENCES,
    title: "Network References",
    description: DESCRIPTIONS[COMPONENT_IDS.NETWORK_REFERENCES],
    width: ComponentsWidth.FULL
  },
  [COMPONENT_IDS.STATIC_ANALYSIS_INSIGHTS]: {
    id: COMPONENT_IDS.STATIC_ANALYSIS_INSIGHTS,
    title: "Static Analysis Insights",
    description: DESCRIPTIONS[COMPONENT_IDS.STATIC_ANALYSIS_INSIGHTS],
    width: ComponentsWidth.HALF
  },
  [COMPONENT_IDS.DYNAMIC_ANALYSIS_INSIGHTS]: {
    id: COMPONENT_IDS.DYNAMIC_ANALYSIS_INSIGHTS,
    title: "Dynamic Analysis Insights",
    description: DESCRIPTIONS[COMPONENT_IDS.DYNAMIC_ANALYSIS_INSIGHTS],
    width: ComponentsWidth.HALF
  },
  [COMPONENT_IDS.YARA_MATCHES]: {
    id: COMPONENT_IDS.YARA_MATCHES,
    title: "YARA Matches",
    description: DESCRIPTIONS[COMPONENT_IDS.YARA_MATCHES],
    width: ComponentsWidth.FULL
  },
  [COMPONENT_IDS.EMAIL]: {
    id: COMPONENT_IDS.EMAIL,
    note: "Shown only for Email samples.",
    title: "Email Information",
    description: DESCRIPTIONS[COMPONENT_IDS.EMAIL],
    width: ComponentsWidth.FULL
  },
  [COMPONENT_IDS.LLM_SUMMARY]: {
    id: COMPONENT_IDS.LLM_SUMMARY,
    title: "AI Summary",
    description: DESCRIPTIONS[COMPONENT_IDS.LLM_SUMMARY],
    width: ComponentsWidth.FULL,
    hide: !settings.FEATURE_LLM_SUMMARY
  }
};

export const getComponents: () => Record<string, DataBlockItem> = () =>
  Object.fromEntries(
    Object.entries(components).filter(([_, { hide }]) => !hide)
  );
